import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
// Push notifications dependencies
import Echo from 'laravel-echo'
/* eslint-disable-next-line no-unused-vars */
import Pusher from 'pusher-js'

// custom and global stylesheets
import '@/assets/css/tailwind.css'
import '@/assets/css/custom.css'

// get token
import { getToken } from './api/pusher'

// custom layouts
import Default from './layout/Default'
import Form from './layout/Form'

// global components
import { BillerRadio, BillerModal, BillerInput, BillerDropdown, BillerNotification } from './components/ui'
import FormTemplate from './components/FormTemplate'
import { mapActions } from 'vuex'

Vue.component('biller-modal', BillerModal)
Vue.component('biller-input', BillerInput)
Vue.component('biller-radio', BillerRadio)
Vue.component('biller-dropdown', BillerDropdown)
Vue.component('biller-notification', BillerNotification)
Vue.component('form-template', FormTemplate)

Vue.config.productionTip = false

// registering layouts
Vue.component('default-layout', Default)
Vue.component('form-layout', Form)

Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and its children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
})

Vue.mixin({
    methods: {
        ...mapActions('Notification', {
            setNotification: 'SET_NOTIFICATION',
        }),
    },
})

const createEcho = (data) => {
    window.Echo = new Echo({
        authEndpoint: process.env.VUE_APP_API_URL + '/api/auth',
        broadcaster: 'pusher',
        key: process.env.VUE_APP_PUSHER_APP_KEY,
        cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
        encrypted: true,
        auth: {
            headers: {
                Authorization: data,
            },
        },
    })
}

const token = localStorage.getItem('token')
if (token === null) {
    getToken().then((data) => {
        localStorage.setItem('token', data.data.token)
        createEcho(data.data.token)
    })
} else {
    createEcho(token)
}

Vue.use(VueMeta)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
